// https://shopify.dev/docs/themes/architecture/templates
export const ShopifyTemplateType = [
  "",
  "404",
  "article",
  "blog",
  "cart",
  "collection",
  // "customers/account",
  // "customers/activate_account",
  // "customers/addresses",
  // "customers/login",
  // "customers/order",
  // "customers/register",
  // "customers/reset_password",
  // "gift_card.liquid",
  "index",
  "list-collections",
  "page",
  "password",
  "product",
  // "robots.txt.liquid",
  "search",
  // "metaobject",
] as const;

export type ShopifyTemplateTypeType = (typeof ShopifyTemplateType)[number];

export interface ShopifyTemplate {
  directory?: string;
  name?: ShopifyTemplateTypeType;
  suffix?: string;
}
